import React, { Component } from "react";
import { connect } from "react-redux";
import Button from "react-bootstrap-button-loader";
import { showError, showSuccess } from "ReduxErrorBar";
import { COMMON_FAIL_MESSAGE } from "Constants";
import {
  openPaymentGatewayInfoModal,
  deleteCardFromStripe,
  deletePayfastInfo,
} from "TicketAction";
import PayfastInfo from "./add-payfast-info";
import LocaleStrings from "Languages";

class Payfast extends Component {
  constructor(props) {
    super(props);
    this.state = { loading: false, showStripBtn: true, stripe_user_id: "" };
  }

  componentDidMount() {}

  updateCard = () => {
    this.props.openPaymentGatewayInfoModal({ showModal: true, update: "card" });
  };

  updateMerchant = () => {
    this.props.openPaymentGatewayInfoModal({
      showModal: true,
      update: "merchant",
    });
  };

  deleteSetup = () => {
    let { session, SettingData } = this.props;
    let payfastStripe = {
      action: "delete",
      stripecustomerid: SettingData.resource[0].stripecustomerid,
      cardid: SettingData.resource[0].stripecustomercardid,
    };
    let values = {
      id: SettingData.resource[0].id,
      paymentgatewaytype: "stripe",
      paymentgatewaysettingjson: null,
      stripecustomerid: null,
      stripecustomercardid: null,
    };

    this.setState({ loading: true });
    this.props.deleteCardFromStripe(session, payfastStripe, (response) => {
      if (response.success) {
        this.props.deletePayfastInfo(session, values, (res) => {
          this.setState({ loading: false });
          if (res.success) {
            this.props.showSuccess(
              LocaleStrings.tickets_payfast_form_card_deleted_success
            );
          } else {
            this.props.showError(COMMON_FAIL_MESSAGE);
          }
        });
      } else {
        this.setState({ loading: false });
        this.props.showError(
          LocaleStrings.tickets_payfast_form_card_deleted_error
        );
      }
    });
  };

  openModal = (e) => {
    this.props.openPaymentGatewayInfoModal({ showModal: true });
  };

  render() {
    let { SettingData, modalStatus, ticketDashboard } = this.props;
    let displayAddBtn = true;
    let anotherPaymentGatwayConnected = false;

    if (
      (ticketDashboard && ticketDashboard.currencies.length > 1) ||
      (ticketDashboard.currencies.length == 1 &&
        ticketDashboard.currencies[0] != "ZAR")
    ) {
      displayAddBtn = false;
    }

    if (
      ticketDashboard &&
      ticketDashboard.paymentgateway == true &&
      ticketDashboard.selectedpaymentgateway != "payfast"
    ) {
      anotherPaymentGatwayConnected = true;
    }

    return (
      <div className="stripe-tab" style={{ width: "60%" }}>
        <div className="row">
          <div className="col-md-12">
            <div className="panel panel-default">
              <div className="panel-heading ticket-report-heading">
                {LocaleStrings.tickets_payfast_text_connect}
              </div>
              {anotherPaymentGatwayConnected === false ? (
                displayAddBtn == true ? (
                  <div className="panel-body">
                    <ul style={{ paddingLeft: 18, marginBottom: 15 }}>
                      <li>{LocaleStrings.tickets_payfast_text_note1}</li>
                      <li>{LocaleStrings.tickets_payfast_text_note2}</li>
                    </ul>
                    <div>
                      {SettingData &&
                      SettingData.resource &&
                      SettingData.resource.length > 0 &&
                      SettingData.resource[0].paymentgatewaytype ===
                        "payfast" &&
                      SettingData.resource[0].paymentgatewaysettingjson &&
                      SettingData.resource[0].paymentgatewaysettingjson != "" &&
                      SettingData.resource[0].stripecustomerid &&
                      SettingData.resource[0].stripecustomerid != "" ? (
                        <div>
                          <button
                            className="btn btn-custom-blue"
                            onClick={this.updateCard}
                          >
                            {LocaleStrings.button_update_pg_card}
                          </button>
                          <button
                            className="btn btn-custom-blue ml-10"
                            onClick={this.updateMerchant}
                          >
                            {LocaleStrings.button_update_pg_merchant}
                          </button>
                          <Button
                            className="btn btn-custom-blue ml-10"
                            onClick={this.deleteSetup}
                            loading={this.state.loading}
                          >
                            {LocaleStrings.button_delete}
                          </Button>
                        </div>
                      ) : (
                        <button
                          onClick={this.openModal}
                          className="btn btn-custom-blue"
                        >
                          {LocaleStrings.button_add_pg_info}
                        </button>
                      )}
                    </div>
                  </div>
                ) : (
                  <div className="panel-body">
                    {
                      LocaleStrings.tickets_payfast_allow_to_integrate_validation1
                    }
                  </div>
                )
              ) : (
                <div className="panel-body">
                  {LocaleStrings.tickets_payfast_allow_to_integrate_validation2}
                </div>
              )}
            </div>
          </div>
          {modalStatus && modalStatus.showModal ? <PayfastInfo /> : ""}
        </div>
      </div>
    );
  }
}

function mapStateToProps(state) {
  return {
    session: state.session,
    SettingData: state.SettingData,
    modalStatus: state.paymentGatewayModal,
    ticketDashboard: state.ticketDashboard.data,
  };
}
export default connect(mapStateToProps, {
  openPaymentGatewayInfoModal,
  deleteCardFromStripe,
  deletePayfastInfo,
  showError,
  showSuccess,
})(Payfast);
